import React from "react";
import Head from "next/head";
import { ThemeProvider } from "@/utils/theme/context";
import "@/styles/global.css";

type AppProps = {
  Component: React.ComponentType;
  pageProps: any;
};

const App = ({ Component, pageProps }: AppProps) => (
  <>
    <Head>
      <meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=no" />
      <meta name="keywords" content="blog, articles, posts, news" />
      <meta name="robots" content="noindex, nofollow" />
      <link rel="icon" href="favicon.ico" sizes="any" />
    </Head>
    <ThemeProvider>
      <Component {...pageProps} />
    </ThemeProvider>
  </>
);

export default App;
